module.exports = __webpack_public_path__ + "static/img/select2.95ab34b0.png";